import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57b8bcd1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b8bcd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b8bcd1')) {
      api.createRecord('57b8bcd1', component.options)
    } else {
      api.reload('57b8bcd1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57b8bcd1&scoped=true", function () {
      api.rerender('57b8bcd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/companyapp/index.vue"
export default component.exports